export default function Django_Deploy_With_EB() {
  return <div>Django_Deploy_With_EB Component</div>;
}
